<template>
  <custom-dialog
    class="service-company-receiving-dialog"
    width="650px"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
  >
    <div class="dialog-body">
      <div class="table-bd">
        <custom-table
          v-model="selectedData"
          height="100%"
          type="checkbox"
          :data="tableList"
          :column="tableColumn"
          :index="true"
          @filter="filterChange"
          @sort="sortChange"
        ></custom-table>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="onConfirm">{{
        $t('Common.com_confirm')
      }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      tableCode: 'service_company_receiving',
      tableList: [{}],
      totalRows: 1,
      selectedData: [],
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1
      }
    };
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      this.closeDialog();
    }
  },
  mounted() {
    this.getTableColumn();
  }
};
</script>

<style></style>
